import { FiltroConsultaMasiva } from '../modelo/ConsultaReciboNovedades';

export const GENERAR_CONSULTA_NOVEDADES_RECIBIDAS_FTP = "GENERAR_CONSULTA_NOVEDADES_RECIBIDAS_FTP";
export const EXITO_CONSULTA_NOVEDADES_RECIBIDAS_FTP = "EXITO_CONSULTA_NOVEDADES_RECIBIDAS_FTP";
export const ERROR_CONSULTA_NOVEDADES_RECIBIDAS_FTP = "ERROR_CONSULTA_NOVEDADES_RECIBIDAS_FTP";

export const ENVIAR_CAMBIO_ESTADO_MASIVO = "ENVIAR_CAMBIO_ESTADO_MASIVO";
export const ENVIO_CAMBIO_ESTADO_MASIVO_EXITO = "ENVIO_CAMBIO_ESTADO_MASIVO_EXITO";
export const ENVIO_CAMBIO_ESTADO_MASIVO_ERROR = "ENVIO_CAMBIO_ESTADO_MASIVO_ERROR";

export const DESCARGAR_PLANTILLA_MASIVO_ESTADO = "DESCARGAR_PLANTILLA_MASIVO_ESTADO";
export const DESCARGAR_PLANTILLA_MASIVO_ESTADO_EXITO = "DESCARGAR_PLANTILLA_MASIVO_ESTADO_EXITO";
export const DESCARGAR_PLANTILLA_MASIVO_ESTADO_ERROR = "DESCARGAR_PLANTILLA_MASIVO_ESTADO_ERROR";

export const ERROR_AUTORIZACION = "ERROR_AUTORIZACION";
export const LIMPIAR_MENSAJES_ESTADO = "LIMPIAR_MENSAJES_ESTADO";

export const generarConsultaNovedadesRecibidasFtp = (filtro: FiltroConsultaMasiva) => ({ type: GENERAR_CONSULTA_NOVEDADES_RECIBIDAS_FTP, filtro });
export const exitoConsultaNovedadesRecibidasFtp = (registrosEncontrados: number, registrosParametro: number, correos: string) => ({
    type: EXITO_CONSULTA_NOVEDADES_RECIBIDAS_FTP, registrosEncontrados, registrosParametro, correos
});
export const errorConsultaNovedadesRecibidasFtp = (mensajeRespuesta: string) => ({ type: ERROR_CONSULTA_NOVEDADES_RECIBIDAS_FTP, mensajeRespuesta });

export const enviarCambioEstadoMasivo = (archivoEnvioMasivo: File) => ({ type: ENVIAR_CAMBIO_ESTADO_MASIVO, archivoEnvioMasivo});
export const envioCambioEstadoMasivoExito = () => ({ type: ENVIO_CAMBIO_ESTADO_MASIVO_EXITO });
export const envioCambioEstadoMasivoError = () => ({ type: ENVIO_CAMBIO_ESTADO_MASIVO_ERROR }); 

export const descargarPlantillaMasivoEstado = () => ({ type: DESCARGAR_PLANTILLA_MASIVO_ESTADO});
export const descargarPlantillaMasivoEstadoExito = () => ({ type: DESCARGAR_PLANTILLA_MASIVO_ESTADO_EXITO});
export const descargarPlantillaMasivoEstadoError = () => ({ type: DESCARGAR_PLANTILLA_MASIVO_ESTADO_ERROR});

export const errorAutorizacion = () => ({ type: ERROR_AUTORIZACION});
export const limpiarMensajesEstado = () => ({ type: LIMPIAR_MENSAJES_ESTADO});


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_masivo/modulos/consultaNovedadesRecibidasActions.ts